import React, { useState } from "react";
import leaf1 from "../Images/leaf1.png";
import perfume from "../../src/Images/infinite girl.JPG";
import perfume2 from "../../src/Images/Dark desire 02.jpg";
import perfume3 from "../../src/Images/Ventura 01.jpg";

const SkinTips = () => {
  const [translate] = useState(true);

  return (
    <div className="relative overflow-hidden bg-white mx-6">
      {/* Decorative leaf for design */}
      <img
        className="absolute w-[80px] hidden lg:w-[250px] top-10 lg:top-[55%] left-0 lg:left-[-60px]"
        alt="Decorative leaf for Clariss expertise section"
        src={leaf1}
        loading="lazy"
      />

      <div className="flex flex-col items-center px-[10px] pt-10 2xl:px-[18%] xl:px-[15%] mx-auto relative mb-10">
        
        {/* ✅ SEO-friendly heading */}
        <h5 className="text-center text-accent font-bold text-3xl mt-10">
          OUR EXPERTISE
        </h5>

        <div className="w-[130px] mx-auto h-1 bg-accent my-6 mb-10 "></div>

        {/* ✅ Product expertise showcase */}
        <div
          className={`flex flex-col sm:flex-row justify-center gap-10 ${
            window.innerWidth <= 1200 ? "flex-wrap" : ""
          }`}
        >
          {/* Dark Desire Perfume */}
          <div className="w-[380px] cursor-pointer rounded flex flex-col items-center relative bg-white animated-element">
            <img
              src={perfume2}
              alt="Clariss Dark Desire Perfume – bold and sophisticated fragrance"
              title="Clariss Dark Desire Perfume"
              className="w-[100%] rounded"
              loading="lazy"
            />
            <span className="sr-only">
              Discover Dark Desire Perfume – a bold fragrance for confident personalities
            </span>
          </div>

          {/* Infinite Girl Perfume */}
          <div className="w-[380px] cursor-pointer rounded flex flex-col items-center relative bg-white animated-element">
            <img
              src={perfume}
              alt="Clariss Infinite Girl Perfume – a refreshing feminine scent"
              title="Clariss Infinite Girl Perfume"
              className="w-[100%] rounded"
              loading="lazy"
            />
            <span className="sr-only">
              Explore Infinite Girl Perfume – a fresh, elegant, and youthful fragrance
            </span>
          </div>

          {/* Ventura Perfume */}
          <div className="w-[380px] cursor-pointer rounded flex flex-col items-center relative bg-white animated-element">
            <img
              src={perfume3}
              alt="Clariss Ventura Perfume – modern and energetic scent"
              title="Clariss Ventura Perfume"
              className="w-[100%] rounded"
              loading="lazy"
            />
            <span className="sr-only">
              Try Ventura Perfume – a vibrant and energetic scent for all-day freshness
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkinTips;
